// extracted by mini-css-extract-plugin
module.exports = {"popup_container":"popup_popup_container__1QKA1","popup_back":"popup_popup_back__3mL-P","popup":"popup_popup__1PYXu"};